var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mobileNav" },
    [
      _vm._t("button", function () {
        return [
          _c(
            "button",
            {
              staticClass: "mobileNav__button openMobileButton",
              class: _vm.buttonClass,
              on: { click: _vm.open },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                    "stroke-width": "3",
                    stroke: "currentColor",
                    fill: "currentColor",
                  },
                },
                [
                  _c("title", [_vm._v("Open Menu")]),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 \n                12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 \n                160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      }),
      _vm._v(" "),
      _c(
        "nav",
        { ref: "menu", staticClass: "mobileNav__menu" },
        [_vm._t("default", null, { isMenuOpen: _vm.isMenuOpen })],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }